export const categories = [
  {
    category: 'Tier 1 Strategy',
    resources: [
      {
        slug: 'Tier1-overview',
        title: 'Overview of Tier 1 Players',
        teaser: 'Discover the key players in large retail: Planners, Buyers...',
        image: '/images/bigbox.png',
      },
      {
        slug: 'Merch-team',
        title: 'Merchandising Teams',
        teaser: 'What national chains have — and how co-ops bridge the gap...',
        image: '/images/merchant.png',
      },
      {
        slug: 'Planograms',
        title: 'Planograms & Power',
        teaser: 'Why big retailers rely on planograms...',
        image: '/images/planogram.png',
      },
      {
        slug: 'Analytics-and-reporting',
        title: 'Analytics & Reporting',
        teaser:
          'How Tier 1 retailers use data — and how you can too with Better Turns.',
        image: '/images/analytics.png',
      },
      {
        slug: 'Inventory-management-guide',
        title: 'Inventory Management: Right Product, Right Time',
        teaser: 'Tier 1 strategies for reducing waste and staying stocked...',
        image: '/images/inventory.png',
      },
    ],
  },
  {
    category: 'Pricing & Promotions',
    resources: [
      {
        slug: 'Pricing-strategy',
        title: 'Pricing Strategy: Big Chain Secrets',
        teaser:
          'How national chains use data-driven pricing—and how you can too.',
        image: '/images/pricing.png',
      },
      {
        slug: 'Vendor-deals-rebates',
        title: 'Vendor Deals & Rebates',
        teaser:
          'How national chains get paid to promote products—and how co-ops can too.',
        image: '/images/deals.png',
      },
      {
        slug: 'Vendor-relationships',
        title: 'Vendor Relationhips',
        teaser:
          'How Tier 1 chains negotiate promotions and rebates from vendors...',
        image: '/images/vendor.png',
      },

      {
        slug: 'vendor-promotion-values',
        title: 'Vendor Promotion Strategy',
        teaser:
          'How to organize and unlock promotional deals in Tier 3 retail.',
        image: '/images/vendorpromotionvalues.png',
      },
      {
        slug: 'Promotion-forecasting',
        title: 'Promotion Forecasting: Avoid Stockouts & Waste',
        teaser:
          'How forecasting turns vendor deals into real profits—used by national chains.',
        image: '/images/forecasting.png',
      },
    ],
  },
];
